import { PrimaryButton, Text } from "flicket-ui";
import React, { isValidElement, ReactNode } from "react";
import CustomModal from "~components/CustomModal";

interface ErrorModalProps {
  error?: {
    title: string;
    message: string | ReactNode;
  };
  onClose: () => void;
}

export const ErrorModal = ({ error, onClose }: ErrorModalProps) => {
  if (!error) return null;

  return (
    <CustomModal isOpen={!!error} close={onClose}>
      <CustomModal.Header>{error?.title ?? ""}</CustomModal.Header>
      <CustomModal.Content>
        <Text variant="regular">
          {typeof error?.message === "string" ? (
            <div>{error.message}</div>
          ) : isValidElement(error.message) ? (
            React.cloneElement(error.message)
          ) : (
            <div>Invalid error message</div>
          )}
        </Text>
      </CustomModal.Content>
      <CustomModal.Footer>
        <PrimaryButton onClick={onClose}>Change selection</PrimaryButton>
      </CustomModal.Footer>
    </CustomModal>
  );
};
